import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { Number } from '../primitive/number';
import { StringOptionalProperty, StringRequired } from '../primitive/string';

const checkoutStep = Schema.Literals(['kosik', 'doprava', 'udaje']);

/**
 * Triggered when a user begins the checkout process
 * Based on: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#initiate_the_checkout_process
 */
export const GtmCheckoutEventSchema = Schema.Struct({
  event: Schema.Literal('track.checkout'),
  checkout_step: checkoutStep,
  ecommerce: Schema.Struct({
    currency: StringRequired,
    value: Number,
    value_to_pay: Number,
    coupon: StringOptionalProperty,
    discount: Number,
    tax: Number,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmBeginCheckoutEventSchema' });

export const GtmCheckoutStep = checkoutStep;
export type GtmCheckoutStep = Schema.Schema.Type<typeof GtmCheckoutStep>;

export type GtmBeginCheckoutEvent = Schema.Schema.Type<typeof GtmCheckoutEventSchema>;
